import { useState, useEffect } from "react";

export interface FactoryAddresses {
  network: string;
  chainId: number;
  rpcUrl: string;
  deployer: string;
  factories: {
    userManager: string;
    openCollectionFactory: string;
    closedCollectionFactory: string;
    directSaleFactory: string;
    auctionSaleFactory: string;
    directSalePieceFactory: string;
    auctionSalePieceFactory: string;
    auctionSalePieceReserveFactory: string;
    fakeERC20: string;
    proofOfCuration: string;
  };
  timestamp: string;
  deploymentInfo?: {
    blockNumber: number;
    gasUsed: number;
  };
  note?: string;
}

export const useFactoryAddresses = () => {
  const [factoryAddresses, setFactoryAddresses] =
    useState<FactoryAddresses | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFactoryAddresses = async () => {
      try {
        const response = await fetch("/factory-addresses.json");
        if (!response.ok) {
          throw new Error("Failed to load factory addresses");
        }
        const data = await response.json();
        setFactoryAddresses(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Unknown error");
        console.warn("Failed to load factory addresses:", err);
      } finally {
        setLoading(false);
      }
    };

    loadFactoryAddresses();
  }, []);

  return { factoryAddresses, loading, error };
};
